import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompanyActions } from './actions/company.actions';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [ CompanyActions ]
})
export class CompanyModule { }
